import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PointComponent } from './point.component';

@NgModule({
	declarations: [PointComponent],
	imports: [CommonModule],
	exports: [PointComponent]
})
export class WmPointModule {}
